import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="min-h-screen bg-[#FFFFFF] flex items-center py-24 md:py-32 px-6 md:px-12 lg:px-24" data-id="element-47">
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-48">
        <div className="flex flex-col space-y-8 order-2 lg:order-1" data-id="element-49">
          <div className="space-y-4" data-id="element-50">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0F0F0F] leading-tight" data-id="element-51">
              Tu agenda está diseñada para trabajar.
              <br data-id="element-52" />
              No para crecer.
            </h1>
            <p className="text-xl md:text-2xl text-[#0F0F0F] leading-relaxed" data-id="element-53">
              El problema no es que trabajes mucho.
              <br data-id="element-54" />
              El problema es en qué estás trabajando.
            </p>
          </div>

          <ul className="space-y-4" data-id="element-55">
            <li className="flex items-start" data-id="element-56">
              <CheckCircle2 className="w-6 h-6 text-[#C9A96E] mr-3 flex-shrink-0 mt-1" data-id="element-57" />
              <span className="text-lg text-[#0F0F0F]" data-id="element-58">
                Descubres qué trabajo en tu agenda no debería existir
              </span>
            </li>
            <li className="flex items-start" data-id="element-59">
              <CheckCircle2 className="w-6 h-6 text-[#C9A96E] mr-3 flex-shrink-0 mt-1" data-id="element-60" />
              <span className="text-lg text-[#0F0F0F]" data-id="element-61">
                Identificas el 20% que genera crecimiento
              </span>
            </li>
            <li className="flex items-start" data-id="element-62">
              <CheckCircle2 className="w-6 h-6 text-[#C9A96E] mr-3 flex-shrink-0 mt-1" data-id="element-63" />
              <span className="text-lg text-[#0F0F0F]" data-id="element-64">
                Re-ordenas tu tiempo, energía y foco
              </span>
            </li>
          </ul>

          <div className="pt-4 flex flex-col items-start space-y-4" data-id="element-65">
            <button className="bg-[#C9A96E] text-[#0F0F0F] font-bold text-lg md:text-xl py-4 px-8 rounded-full hover:opacity-90 transition-opacity w-full md:w-auto" data-id="element-66">
              DESCUBRIR MI 20% CRÍTICO
            </button>
            <p className="text-sm text-[#0F0F0F] opacity-80 font-medium" data-id="element-67">
              90 minutos · Zoom en vivo · $15
              <br data-id="element-68" />
              Sábado 11 de abril - 10 am (Vzla)
            </p>
          </div>
        </div>

        <div className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-69">
          <img src="https://cdn.magicpatterns.com/uploads/1twgEDVpf4inYN6gPeyzRN/Foto_1.jpg" alt="Carolina" className="w-full max-w-md lg:max-w-lg rounded-2xl object-cover shadow-2xl" data-id="element-70" />
        </div>
      </div>
    </section>;
}